export type OAuthCallbackParams = {
  code: string | null;
  state: string | null;
  error: string | null;
  errorDescription: string | null;
};

declare global {
  interface Window {
    __WEAVY_OAUTH_CALLBACK_PARAMS__?: OAuthCallbackParams;
  }
}

export const OAUTH_CALLBACK_QUERY_PARAMS = {
  code: 'code',
  state: 'state',
  error: 'error',
  errorDescription: 'error_description',
} as const;

/** Reads the bootstrap handoff, with a URL fallback for documents without the bootstrap. */
export const getOAuthCallbackParams = (): OAuthCallbackParams => {
  if (typeof window === 'undefined') {
    return { code: null, state: null, error: null, errorDescription: null };
  }

  if (window.__WEAVY_OAUTH_CALLBACK_PARAMS__) {
    return window.__WEAVY_OAUTH_CALLBACK_PARAMS__;
  }

  const params = new URLSearchParams(window.location.search);
  return {
    code: params.get(OAUTH_CALLBACK_QUERY_PARAMS.code),
    state: params.get(OAUTH_CALLBACK_QUERY_PARAMS.state),
    error: params.get(OAUTH_CALLBACK_QUERY_PARAMS.error),
    errorDescription: params.get(OAUTH_CALLBACK_QUERY_PARAMS.errorDescription),
  };
};

/** Clears callback values after a consumer has claimed the one-time handoff. */
export const clearOAuthCallbackParams = (): void => {
  if (typeof window !== 'undefined') {
    delete window.__WEAVY_OAUTH_CALLBACK_PARAMS__;
  }
};
